module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-2@2x_0ba1b31f3839db3ec8c90d48e7b8b8ec.png";